import{gql as i}from"@apollo/client";i`
  query File($id: ID!) {
    file(id: $id) {
      id
      name
      url
      isPublic
    }
  }
`,i`
  query Files($limit: Int, $offset: Int, $order: FileOrderArgType, $filter: FileFilterArgType!) {
    files(limit: $limit, offset: $offset, order: $order, filter: $filter) {
      totalCount
      data {
        id
        name
        url
        isPublic
        createdAt
        status
      }
    }
  }
`;